/* Publish by EComposer at 2024-06-17 16:09:37*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rmnmpmnfdrs"]=  window.__ectimmers["ecom-rmnmpmnfdrs"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-rmnmpmnfdrs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rmnmpmnfdrs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x0ketm5qq1g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x0ketm5qq1g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5wqv0b6x534').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5wqv0b6x534', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5frai7xethm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5frai7xethm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a73czsszt25').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a73czsszt25', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3ytafb6qqe3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3ytafb6qqe3', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6vldh5zrgbq"]=  window.__ectimmers["ecom-6vldh5zrgbq"] || {};
const t=this.$el;if(!t)return;let r=this.settings.link_redirect,i=t.querySelector('.ecom-contact-form-file[type="file"]');const _=this.id;function g(){if(!r)return!1;let l=r.href;if(l=="")return!1;let m=r.target;window.location.href.includes("contact_posted=true")&&(m==="_blank"?window.open(l):window.location.href=l)}g();const o=t.querySelector("#ecom-contact-form-"+_);if(!o)return;const n=o.querySelector(".ecom__form-button");if(!n)return;i&&(o.setAttribute("enctype","multipart/form-data"),o.addEventListener("submit",function(l){if(!i.value||i.value==="")return;l.preventDefault(),l.stopImmediatePropagation(),n.classList.add("ecom-ajax-loading","ecom-loading");const m=o.querySelector('input[type="file"]');let e=new FormData,c=window.location.origin,u=window.EComposer&&window.EComposer.proxy_path;const w=`${c}${u}/contact-form`;e.append("file",m.files[0]),m.value&&u&&fetch(w,{method:"POST",body:e}).then(d=>d.json()).then(d=>{if(d.status==="success"){let q=m.name;m.remove();let x=document.createElement("input");x.value=d.src_file,x.type="hidden",x.name=q,o.appendChild(x),o.submit()}else alert(`Notice: ${d.message}`)}).catch(d=>console.error(d)).finally(function(){n.classList.remove("ecom-ajax-loading","ecom-loading")})}),i.addEventListener("change",function(){this.files[0].size>10485760&&(this.value="",alert("File size exceeds the maximum allowed limit (10MB)."))}));let f=t.querySelectorAll(".ecom-required--checkbox");n.addEventListener("click",function(l){f.length>0&&f.forEach(function(m){let e=m.querySelectorAll("input[type=checkbox]");if(e.length==0)return;let c=!1;e.forEach(function(u){u.checked&&(c=!0)}),c?e.forEach(function(u){u.required=!1}):e.forEach(function(u){u.required=!0})})}),o.dataset.ecTrackingId&&o.addEventListener("submit",function(){window.Shopify&&window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:o.id,tracking_id:o.dataset.ecTrackingId})},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-6vldh5zrgbq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6vldh5zrgbq', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ioxwhh9xlos"]=  window.__ectimmers["ecom-ioxwhh9xlos"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}

                    });
                    
                        document.querySelectorAll('.ecom-ioxwhh9xlos').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ioxwhh9xlos', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-brb7klvobu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-brb7klvobu', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ltaya1u0t8g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ltaya1u0t8g', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}